import { render, staticRenderFns } from "./PItemRowVideo.vue?vue&type=template&id=0fecd530"
import script from "./PItemRowVideo.vue?vue&type=script&lang=js"
export * from "./PItemRowVideo.vue?vue&type=script&lang=js"
import style0 from "./PItemRowVideo.vue?vue&type=style&index=0&id=0fecd530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports